<template>
  <div>
    <div v-if="hasData">
      <div v-for="contract in contracts" :key="contract.contract_no">
        <q-list bordered padding v-if="activeContract != contract.contract_no">
          <q-item tag="label" v-ripple @click="setActiveContract(contract.contract_no)">
            <q-item-section>
              <q-item-label>เลขที่สัญญา</q-item-label>
            </q-item-section>
            <q-item-section side >
              {{ contract.contract_no }}
            </q-item-section>
          </q-item>
        </q-list>
        <q-list bordered padding v-else>
          <!-- <q-item-label header>Notifications</q-item-label> -->
          <q-item tag="label" v-ripple>
            <q-item-section>
              <q-item-label>เลขที่สัญญา</q-item-label>
            </q-item-section>
            <q-item-section side >
              {{ contract.contract_no }}
            </q-item-section>
          </q-item>

          <q-item tag="label" v-ripple>
            <q-item-section>
              <q-item-label>วันที่เริ่มต้นสัญญา</q-item-label>
            </q-item-section>
            <q-item-section side >
              {{ formatDate(contract.contract_date) }}
            </q-item-section>
          </q-item>

          <q-item tag="label" v-ripple>
            <q-item-section>
              <q-item-label>ชื่อลูกค้า</q-item-label>
            </q-item-section>
            <q-item-section side >
              {{ contract.customer_name }}
            </q-item-section>
          </q-item>

          <q-item tag="label" v-ripple>
            <q-item-section>
              <q-item-label>ยอดเงินรวม</q-item-label>
            </q-item-section>
            <q-item-section side >
              {{ formatMoney(contract.amount) }}
            </q-item-section>
          </q-item>

          <q-item tag="label" v-ripple>
            <q-item-section>
              <q-item-label>ยอดเงินที่ชำระแล้ว</q-item-label>
            </q-item-section>
            <q-item-section side >
              {{ formatMoney(contract.paid) }}
            </q-item-section>
          </q-item>

          <q-item tag="label" v-ripple>
            <q-item-section>
              <q-item-label>จำนวนยอดที่ยังชำระไม่เสร็จสิ้น</q-item-label>
            </q-item-section>
            <q-item-section side >
              {{ formatMoney(contract.not_paid) }}
            </q-item-section>
          </q-item>

          <q-item tag="label" v-ripple>
            <q-item-section>
              <q-item-label>จำนวนที่ชำระเงินครั้งล่าสุด</q-item-label>
            </q-item-section>
            <q-item-section side >
              {{ formatMoney(contract.last_paid) }}
            </q-item-section>
          </q-item>

          <q-item tag="label" v-ripple>
            <q-item-section>
              <q-item-label>วันที่ ที่ชำระเงินครั้งล่าสุด</q-item-label>
            </q-item-section>
            <q-item-section side >
              {{ formatDate(contract.last_paid_date) }}
            </q-item-section>
          </q-item>

          <q-item tag="label" v-ripple>
            <q-item-section>
              <q-item-label>สถานะการออกใบเสร็จรับเงิน</q-item-label>
            </q-item-section>
            <q-item-section side >
              {{ contract.invoice_status }}
            </q-item-section>
          </q-item>

          <q-item v-if="contract.invoice_url !== ''" @click="openInvoice(contract.invoice_url)" tag="label" v-ripple>
            <q-item-section>
              <q-item-label>ดูข้อมูล Invoice</q-item-label>
            </q-item-section>
            <q-item-section side >
              <q-icon name="keyboard_arrow_right"/>
            </q-item-section>
          </q-item>

          <q-item v-else tag="label" v-ripple>
            <q-item-section>
              <q-item-label>ดูข้อมูล Invoice</q-item-label>
            </q-item-section>
            <q-item-section side >
              ไม่มีข้อมูล
            </q-item-section>
          </q-item>

        </q-list>
      </div>
    </div>
    <div v-else>
        <q-banner class="bg-grey-3">
          <template v-slot:avatar>
            <q-icon name="error_outline" color="primary" />
          </template>
          No data
        </q-banner>
      </div>
  </div>

</template>

<script>
import { Loading } from 'quasar'
import { mapActions, mapState } from 'vuex'
import axios from 'axios'

export default {
  data () {
    return {
      contractShow: false,
      activeContract: 1,
      hasData: true,
      contracts: [
        {
          contract_no: '',
          contract_status: '',
          contract_date: '',
          customer_name: '',
          citizen_id: '',
          amount: '',
          paid: '',
          not_paid: '',
          last_paid: '',
          last_paid_date: '',
          invoice_status: 'N',
          invoice_url: ''
        }
      ]
    }
  },
  methods: {
    ...mapActions('auth', ['handleLogin', 'setActiveRoute', 'setForbidden']),
    openInvoice (invoiceUrl) {
      // if (this.contract.invoice_url) {
      window.location = invoiceUrl
      // }
    },
    firstContract () {
      this.setActiveContract(this.contracts[0].contract_no)
    },
    setActiveContract (contractNo) {
      this.activeContract = contractNo
    },
    formatNumber (number) {
      return new Intl.NumberFormat('th-TH', { maximumSignificantDigits: 3 }).format(number)
      // return new Intl.NumberFormat('th-TH', { style: 'currency', currency: 'THB' }).format(number)
    },
    formatMoney (amount, decimalCount = 2, decimal = '.', thousands = ',') {
      try {
        decimalCount = Math.abs(decimalCount)
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount

        const negativeSign = amount < 0 ? '-' : ''

        const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
        const j = (i.length > 3) ? i.length % 3 : 0

        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
      } catch (e) {
        console.log(e)
        return amount
      }
    },
    formatDate (dt) {
      if (dt !== null && dt.length > 9) {
        const datetime = new Date(dt)
        return `${datetime.getDate()}/${(datetime.getMonth() + 1)}/${datetime.getFullYear()}`
      } else {
        return '-'
      }
    }
  },
  computed: {
    ...mapState('auth', ['apiToken'])
  },
  mounted () {
    Loading.show()
    this.setActiveRoute('statement')
    this.handleLogin()

    const token = this.apiToken
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    }
    axios.get(`${process.env.VUE_APP_API}api/contracts`, config)
      .then((res) => {
        Loading.hide()
        console.log(res)
        if (res.data != null) {
          console.log(res.data)
          if (res.data.length > 0) {
            this.contracts = res.data
            this.firstContract()
            this.hasData = true
          } else {
            this.hasData = false
            console.log('empty')
          }
        }
      })
      .catch(e => {
        Loading.hide()
        this.setForbidden()
        // console.log(e.toJSON())
        // if (e.response.status === 401) {
        // console.log(e.response.status)
        this.$router.push('/register', () => {})
        // }
      })
  }
}
</script>
